// feat_404 — borrador de la consulta. Texto + ticket precargado en
// sessionStorage (por empresa y usuario); imágenes en memoria de módulo
// (no caben en storage y sólo tienen que sobrevivir a la navegación interna).
export const MAX_TEXT = 2000;
export const MAX_IMAGES = 3;
export const MAX_IMAGE_BYTES = 5 * 1024 * 1024;
export const ALLOWED_TYPES = ["image/png", "image/jpeg", "image/webp"];

let memoryImages = [];

const key = user => `waia:supportDraft:${user?.companyId || 0}:${user?.id || 0}`;

export const loadDraft = user => {
  try {
    const raw = sessionStorage.getItem(key(user));
    const d = raw ? JSON.parse(raw) : {};
    return {
      text: typeof d.text === "string" ? d.text.slice(0, MAX_TEXT) : "",
      ticket: d.ticket && Number(d.ticket.id) > 0 ? d.ticket : null,
      whatsappId: d.whatsappId ? String(d.whatsappId) : "",
      images: memoryImages,
    };
  } catch (_) {
    return { text: "", ticket: null, whatsappId: "", images: memoryImages };
  }
};

export const saveDraft = (user, { text, ticket, whatsappId, images }) => {
  memoryImages = images || [];
  try {
    sessionStorage.setItem(key(user), JSON.stringify({ text, ticket, whatsappId }));
  } catch (_) {}
};

export const clearDraft = user => {
  memoryImages = [];
  try {
    sessionStorage.removeItem(key(user));
  } catch (_) {}
};

// Valida una imagen en cliente. Devuelve la clave i18n del error o null.
export const validateImage = (file, currentCount) => {
  if (!file || !ALLOWED_TYPES.includes(file.type)) return "support.errType";
  if (file.size > MAX_IMAGE_BYTES) return "support.errSize";
  if (currentCount >= MAX_IMAGES) return "support.errCount";
  return null;
};
